import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var departmentListRes;
export const departmentListTodo = createAsyncThunk('departmentList', async (data) => {


    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'superadmin/department',
           
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return departmentListRes = res.data

    } catch (error) {
        return departmentListRes = error.response.data
    }
});

const departmentListSlice = createSlice({
    name: 'departmentList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(departmentListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(departmentListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default departmentListSlice.reducer; 